import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { SaveCMRAgentEventDto } from '@shared/src/dtos/route/cmr/agent/SaveCMRAgentEventDto';
import { BaseCMREventDto } from '@shared/src/dtos/route/cmr/BaseCMREventDto';
import { CMREventTypes } from '@shared/src/enums/CMREventTypes';
import { AlertService, HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-agent-actions-newevent',
    templateUrl: './shared.external.cmr.agent.actions.newevent.component.html',
    styleUrls: ['./shared.external.cmr.agent.actions.newevent.component.scss']
})
export class SharedExternalCMRAgentActionsNewEventComponent implements OnInit {

    public formGroup: FormGroup;
    public useIonic: boolean = false;
    constructor(private fb: FormBuilder, protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteController: OpenRouteController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();

        this.formGroup = fb.group({
            'event': ['', Validators.maxLength(255)]
        });
    }

    ngOnInit(): void {
    }
    
    @Input() public readonly: boolean;

    public __uuidQR: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.wellcome();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }

    public __agent: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.__agent === value)
            return;
        this.__agent = value;
        this.wellcome();
    }
    public get agent(): RouteCMRAgents {
        return this.__agent;
    }

    public events: BaseCMREventDto[];
    public getListEvents(){
        if(this.events == null)
            return new Array();
        return this.events;
    }
    loadData() {
        if (!HString.isNullOrNullString(this.uuidQR) && RouteCMRAgentsEnum.isValid(this.agent)) {
            this.openRouteCMRController.getRouteCMRAgentEventsByUUID(this.uuidQR, this.agent).subscribe(data => { 
                this.events = data;
            });
        }
    }

    public canAddEvents: boolean;
    public wellcome() {

        if (!HString.isNullOrNullString(this.uuidQR) && RouteCMRAgentsEnum.isValid(this.agent)) {
            this.openRouteCMRController.getCanAddRouteCMRAgentEventsByUUID(this.uuidQR, this.agent).subscribe(data => { 
                this.canAddEvents = data;
                this.readonly = this.readonly || !this.canAddEvents;
                this.buildOptions();
            });
        }else{
            this.options = new OptionsStripDto();
        }

    }


    public options: OptionsStripDto;
    public selectedOption: OptionDto = null;
    public buildOptions() {
   
        this.options = new OptionsStripDto();
        if(!this.canAddEvents){
            this.selectedOptionId = "LISTEVENTS";
        }else{
            this.options.add(OptionDto.build('ADDEVENT', 'ROUTEPARTCMR.EVENT.NEW.TITLE', null, null, 1, -1, 1, true, false));
            this.options.add(OptionDto.build('LISTEVENTS', 'ROUTEPARTCMR.EVENT.LIST.TITLE', null, null, 2, -1, 1, false, false));
            this.onClickOption(this.options.getActualSelected());
        }
    }

    public selectedOptionId = "";
    onClickOption(option: OptionDto) {
        if (option != null)
            this.selectedOptionId = option.optionId;
        else
            this.selectedOptionId = "";

        if(this.selectedOptionId == "LISTEVENTS"){
            this.loadData();
        } else if(this.selectedOptionId == "ADDEVENT"){
            this.event = "";
        }
    }
    
    private _event: string;
        set event(value: string) {
        if (this._event === value)
            return;
        this._event = value;
    }

    get event(): string {
        return this._event;
    }


    public isValid: boolean = false;
    ngAfterViewInit() {
        this.formGroup.valueChanges.subscribe((change) => {
            this.isValid = this.formGroup.valid;
            this.pendingSave = !HString.isNullOrNullString(change);
        });
        
    }

    public pendingSave: boolean;
    
    onAddEvent() {
 
        if (!HString.isNullOrNullString(this.uuidQR) && RouteCMRAgentsEnum.isValid(this.agent)) {
            this.openRouteCMRController.saveRouteCMRAgentEventByUUID(this.uuidQR, this.agent, SaveCMRAgentEventDto.build(this.event, CMREventTypes.Generic)).subscribe(data => {
                if(data){
                    this._event = "";
                    this.pendingSave = false;
                }
            });
        }
    
    }

}
